/**
 * 参与列表签到标签可见性裁决（纯函数）。
 * 与小程序端 solataireGroupDetails 页面保持同一套规则，供活动详情页参与列表复用。
 *
 * 值域约定（历史契约，宽松相等）：
 * - checkInStatusSwitch「签到状态可见范围」：1=仅创建者和管理员可见，2=所有人可见；
 * - isShowSignStatus 页面级放行开关：1=放行全部；身份接口返回前的初始值（如 99）不放行；
 * - checkInStatusSwitch == 1 且观看者为普通用户时，本人仍可看到自己的签到状态（本人豁免）。
 *
 * @param {Object} pageState 页面级状态
 * @param {number|string} pageState.isShowSignStatus 页面级放行开关
 * @param {number|string} pageState.checkInStatusSwitch 签到状态可见范围设置
 * @param {number|string} pageState.memberId 当前用户标识
 * @param {Object|null} item 参与列表条目（需含 user_id）
 * @returns {boolean} 该条目是否展示签到标签
 */
export function canShowSignStatus(pageState, item) {
  if (!item) return false;
  if (!pageState) return false;
  if (pageState.isShowSignStatus == 1) return true;
  return (
    pageState.checkInStatusSwitch == 1 &&
    pageState.memberId == item.user_id
  );
}
